module.exports = __webpack_public_path__ + "img/highest-price.0d69740e.png";